import React, { FC } from 'react';
import Select, { GroupBase, StylesConfig } from 'react-select';

interface IProps {
  yearsOptions: { label: number; value: number }[];
  filingTypesOptions: { label: string; value: string }[];
  onYearChange: (value: number | null) => void;
  onFilingTypeChange: (value: string | null) => void;
}

const Filters: FC<IProps> = ({
  filingTypesOptions,
  yearsOptions,
  onFilingTypeChange,
  onYearChange,
}) => {
  const customStyles: StylesConfig<
    {
      label: string | number;
      value: string | number;
    },
    false,
    GroupBase<{
      label: string | number;
      value: string | number;
    }>
  > = {
    control: (provided, state) => ({
      ...provided,
      border: 0,
      boxShadow: 'none',
    }),
    menu: (provided, state) => ({
      ...provided,
      background: '#F5F7F6',
      padding: '10px 20px',
    }),
    option: (provided, state) => ({
      ...provided,
      cursor: 'pointer',
      borderBottom: state.isSelected
        ? '3px solid #FFB81C'
        : '1px solid #C5C6C7',
      color: state.isSelected ? '#FFB81C' : '#003349',
      fontWeight: state.isSelected ? 'bold' : 'normal',
      padding: 12,
      fontSize: '15px',
      background: 'transparent !important',
      textAlign: 'center',
    }),
  };
  const commonSelectProps = {
    styles: customStyles,
    isClearable: true,
    className: 'filings__filters--select',
    isSearchable: false,
  };

  return (
    <div className="filings__filters--container">
      <Select
        {...commonSelectProps}
        placeholder="Filter by Year"
        options={yearsOptions}
        onChange={(newValue) => {
          onYearChange(newValue?.value as number | null);
        }}
      />
      <Select
        {...commonSelectProps}
        placeholder="Filter by Filing Type"
        options={filingTypesOptions}
        onChange={(newValue) => {
          onFilingTypeChange(newValue?.value as string | null);
        }}
      />
    </div>
  );
};

export default Filters;
